import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="mt-16 bg-background-100 border-t border-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-flashlight-fill text-lg"></i>
              </span>
              <span className="font-heading text-2xl text-foreground-950">抖漫</span>
            </Link>
            <p className="mt-4 text-sm leading-6 text-foreground-600">
              抖漫专注碎片化观看场景，提供抖漫速看、抖漫精选、抖漫片段内容。通勤路上、睡前放松或日常休息，打开抖漫即可快速进入漫画世界。
            </p>
          </div>

          <nav aria-label="内容分类">
            <h4 className="text-sm font-bold text-foreground-950 mb-4">内容分类</h4>
            <ul className="space-y-3 text-sm text-foreground-600">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link to={`/category/${c.slug}`} className="hover:text-primary-600 transition-colors whitespace-nowrap">
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="快捷导航">
            <h4 className="text-sm font-bold text-foreground-950 mb-4">快捷导航</h4>
            <ul className="space-y-3 text-sm text-foreground-600">
              <li><Link to="/" className="hover:text-primary-600 transition-colors whitespace-nowrap">首页</Link></li>
              <li><Link to="/category/jingxuan" className="hover:text-primary-600 transition-colors whitespace-nowrap">抖漫精选</Link></li>
              <li><Link to="/category/shuiqian" className="hover:text-primary-600 transition-colors whitespace-nowrap">睡前放松</Link></li>
              <li><Link to="/about" className="hover:text-primary-600 transition-colors whitespace-nowrap">关于我们</Link></li>
            </ul>
          </nav>

          <div>
            <h4 className="text-sm font-bold text-foreground-950 mb-4">联系我们</h4>
            <ul className="space-y-3 text-sm text-foreground-600">
              <li className="flex items-center gap-2"><i className="ri-mail-line text-primary-500"></i> hello@douman.example.com</li>
              <li className="flex items-center gap-2"><i className="ri-phone-line text-primary-500"></i> 400-800-2026</li>
              <li className="flex items-center gap-2"><i className="ri-map-pin-line text-primary-500"></i> 中国 · 杭州</li>
            </ul>
            <div className="mt-4 flex gap-3">
              {["ri-weibo-line", "ri-wechat-line", "ri-bilibili-line", "ri-douban-line"].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  rel="nofollow"
                  aria-label="社交媒体"
                  className="flex h-10 w-10 items-center justify-center rounded-full bg-background-200/80 text-foreground-700 hover:bg-primary-500 hover:text-background-50 transition-colors"
                >
                  <i className={`${icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-foreground-500">
          <p>© 2026 抖漫 · 专注碎片化漫画阅读平台</p>
          <p>本平台内容仅供学习交流 · 浙ICP备2026000000号</p>
        </div>
      </div>
    </footer>
  );
}